/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import PatientOverview from 'DesignSystem/PatientOverview/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/Old/PatientPreview/Content"
  
}) {
let appointmentOverlayPatientIdValueData = fromData.useDataValue({ viewPath,
context: 'appointment_overlay',
path: 'patient_id',
})
  return (<React.Fragment
>
<PatientOverview
  viewPath={`${viewPath}/PatientOverview`}
 data="appointment_overlay.patient_id"
 patientId={appointmentOverlayPatientIdValueData}
/>
{children}
</React.Fragment>)
}